import { skipToken } from '@tanstack/react-query';
import { trpc } from '@portal/trpc/client';

export const usePriceRates = (resourceTypeId?: number) => {
  return trpc.nexudus.getResourceTypePricing.useQuery(
    resourceTypeId == null ? skipToken : { id: resourceTypeId },
    {
      staleTime: 1000 * 60,
    },
  );
};
